function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.675,
  cy: 17.666,
  r: 15,
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2410_66472)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.79 19.99l.86 1.85c.08.19.18.37.25.56.3.72.01 1.53-.69 1.88-.26.14-.54.27-.82.32a1.42 1.42 0 01-1.57-.84l-1.25-2.67-.1-.2-1.28.53c-.18.08-.36.18-.55.25-.7.27-1.5 0-1.83-.67-.45-.92-.88-1.85-1.3-2.78-.31-.74.03-1.55.8-1.9 1.35-.63 2.6-1.38 3.79-2.26a18.53 18.53 0 004.59-4.75c.64-.99 2.07-.9 2.57.17 1.28 2.71 2.54 5.43 3.79 8.15.5 1.08-.35 2.17-1.56 2.07a17.4 17.4 0 00-5.59.24l-.12.05zm2.94-1.67l-2.8-6-.15.18a22.3 22.3 0 01-3.54 3.02 22.19 22.19 0 01-3.36 1.92c-.15.07-.26.16-.17.35l1.19 2.56c.07.15.18.18.32.12l.18-.08a22.78 22.78 0 017.17-1.96l1.16-.1zm2.9.1c.27.03.35-.1.24-.34l-3.71-7.99c-.12-.25-.3-.26-.46-.03-.24.36-.5.72-.75 1.06-.09.12-.09.2-.03.33l.78 1.66 2.34 5.02c.04.08.12.17.2.18.46.05.93.07 1.4.1v.01zm-7.12 1.84l-.81.23.1.23 1.03 2.22c.16.34.4.42.74.25.2-.1.23-.18.14-.38l-.8-1.7-.4-.85z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2410_66472"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15.8v16H0z",
  transform: "translate(9.4 8.623)"
})));

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.8bbc07ef.svg";
export { ForwardRef as ReactComponent };